
export enum ProcessStatusCd {
	COMPLETED = 'Completed',
	FAILED = 'Failed'}
